import Vue from 'vue';
import BzbsApi from '@/core/Http/BzbsApi.js';

export default {
    apiCartItem: function (token) {
        return new Promise((resolve, reject) => {
            var url = `${Vue.bzbsConfig.bzbsUrl}/cart/list_summary`;
            BzbsApi.connectBzbsGet(url, token)
                .then(res => {
                    var totalAmount = 0;
                    var list = res.data.list;
                    if (list) {
                        for (var items of list) {
                            for (var item of items.items) {
                                totalAmount += item.Quantity;
                            }
                        }
                    }

                    resolve(totalAmount);
                }).catch(err => {
                    reject(err);
                });
        });
    },
    apiAddItemToCart: function (token, cartParams) {
        // var items = [{
        //     id: campaignId,
        //     qty: quantity
        // }];

        // var params = {
        //     json: JSON.stringify(items),
        //     mode: 'add'
        // };

        return new Promise((resolve, reject) => {
            var url = `${Vue.bzbsConfig.apiShoppingCartUrl}/cart/adds`;
            BzbsApi.connectBzbsPost(url, token, cartParams)
                .then((res) => {
                    resolve(res.data);
                }).catch(err => {
                    reject(err);
                });
        });
    }
}
